import React, {useState, useEffect} from 'react';
import { Button, Typography, Box, Spacer } from '@telus-uds/components-web';


import axios from 'axios';
import FileDownload from 'js-file-download';
import {config, apiHost} from '../utils/request';
import {useTranslationsContext} from '../context/TranslationsContext';
import {stylePage, styleInputField, styleTextBold, ErrorStyles} from './styles';
import ValidateLoader from '../UI/validateLoader';

const Reporting = ({history}) => {
    const {
        WLS: {
            REPORTING: {
                Reporting,
                RequiredField,
                StartDate,
                EndDate,
                Total,
                FilterResults,
                ExportCSV
            }
        }
    } = useTranslationsContext();

    const [loading, setLoading] = useState(false);
    const [showExportButton, setShowExportButton] = useState(false);
    const [ordersList, setOrdersList] = useState();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const [error, setError] = useState('');
    const [totalOrders, setTotalOrders] = useState(0);;
    const userProfile = JSON.parse(localStorage.getItem('userProfile'));
    const {
        role: {name = ''} = {}
    } = userProfile || {};


    if (name !== 'ADMIN') {
        history.push('/');
    }


    const validateInput = () => {
        if (startDate.length > 0 && endDate.length > 0) {
            return true
        } else {
            if (startDate.length <= 0) {
                setStartDateError(RequiredField)
            }
            if (endDate.length <= 0) {
                setEndDateError(RequiredField)
            }
            return false
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const postData = () => {
        if (validateInput()) {
            setStartDateError('');
            setEndDateError('');
            setLoading(true);
            // API to fetch all the orders
            axios.post(`${apiHost}/orders/export/wls-report?typeOfOrder=WLS`, {startDate, endDate}, config())
                .then((response) => response.data)
                .then((fileData) => {
                    setOrdersList(fileData)
                    // API to fetch count of all the orders
                    axios.post(`${apiHost}/orders/getReportCount?typeOfOrder=WLS`, {startDate, endDate}, config())
                        .then((resposne) => setTotalOrders(resposne.data.total))
                        .catch((error) => setError(error))
                })
                .catch((error) => setError(error))
                .finally(() => {
                    setLoading(false)
                    setShowExportButton(true)
                })
        }
    }

    const exportFile = () => {
        FileDownload(ordersList, 'WLS_Orders.csv')
    }

    return (
        <>
            <div style={stylePage}>
                <div className="container 85%">
                    <div id="main">
                        <div id="main-wrapper">
                            <div id="main-content">
                                {loading && <ValidateLoader message="LOADING"/>}
                                <Typography heading="h1" variant={{ size: 'h1' }} block>{Reporting}</Typography>
                                <Spacer space={3} />
                                <Box tag="fieldset" space={2} style={styleInputField}>
                                    <label style={styleTextBold}><Typography>{StartDate}</Typography></label>
                                </Box>
                                <input
                                    type="date"
                                    className="frg-input-field color-light"
                                    style={{width: '100%'}}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <div style={ErrorStyles}><Typography>{startDateError}</Typography></div>
                                <Box tag="fieldset" space={2} style={styleInputField}>
                                    <label style={styleTextBold}><Typography>{EndDate}</Typography></label>
                                </Box>
                                <input
                                    type="date"
                                    className="frg-input-field color-light"
                                    style={{width: '100%'}}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                                <div style={ErrorStyles}><Typography>{endDateError}</Typography></div>
                                {error.length > 0 ? <Typography block>{error}</Typography> : ''}
                                <br/><br/>
                                <Typography block>{Total}: {totalOrders}</Typography>
                                <br/><br/>
                                <Button variant={{ priority: 'high' }} style={{marginRight: 5}}
                                        type='button' onClick={() => postData()}>
                                    {FilterResults}
                                </Button>
                                <Button variant={{ priority: 'high' }} type='button'
                                        disabled={!showExportButton} onClick={() => exportFile()}>
                                    {ExportCSV}
                                </Button>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Reporting;